export enum StrategyLayerType {
  ALTERNATIVE_ROUTING = 'ALTERNATIVE_ROUTING',
  PARK_GUIDANCE_CITY_AVOIDANCE = 'PARK_GUIDANCE_CITY_AVOIDANCE',
  GEVAS = 'GEVAS',
}
